import { render, staticRenderFns } from "./software.vue?vue&type=template&id=27af9b71&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"
import style0 from "./software.vue?vue&type=style&index=0&id=27af9b71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af9b71",
  null
  
)

export default component.exports